module.exports = __webpack_public_path__ + "de04707d83f273268a8001f37ec1baf3.pdf";